import { TagLimited } from '@vpp-frontend-components/tag-limited';

export default TagLimited;
